
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface DueDiligenceStepProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  details: string;
  stepNumber: number;
}

const DueDiligenceStep = ({ icon, title, description, details, stepNumber }: DueDiligenceStepProps) => {
  return (
    <Card className="hover:shadow-lg transition-shadow duration-300">
      <CardHeader>
        <div className="flex items-center space-x-4 mb-4">
          <div className="flex-shrink-0">
            {icon}
          </div>
          <div>
            <CardTitle className="text-xl">{title}</CardTitle>
            <div className="flex items-center mt-2">
              <span className="bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded">
                Step {stepNumber}
              </span>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-gray-700 mb-4">{description}</p>
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm text-gray-600 italic">{details}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default DueDiligenceStep;
